import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FaqStrip() {
  const faqs = [{
    question: 'How often should I have my pool serviced?',
    answer: 'We recommend weekly maintenance to keep your water balanced and your equipment running efficiently. We can also customize a schedule based on your needs.'
  }, {
    question: 'What if my pool has algae or cloudy water?',
    answer: "No worries. We specialize in algae removal and water restoration. We'll diagnose the issue, balance the chemicals, and get your water back to crystal clear."
  }, {
    question: 'Do you offer one-time cleanings?',
    answer: 'Yes. Whether you need a single deep clean before an event or want to test us out before committing to a plan, we have you covered.'
  }, {
    question: 'What areas do you serve?',
    answer: 'We serve Madison, Ridgeland, Jackson, Gluckstadt, Flowood, Canton, and surrounding communities.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-16 md:py-24 bg-white" data-id="element-79">
      <div className="container mx-auto px-6 md:px-8 max-w-3xl" data-id="element-80">
        <div className="text-center mb-12" data-id="element-81">
          <div className="text-brand-amber text-sm font-bold tracking-widest uppercase mb-4" data-id="element-82">
            FAQ
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-text" data-id="element-83">
            Quick answers to common questions.
          </h2>
        </div>

        <div className="space-y-0 border-t border-gray-200" data-id="element-84">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200" data-id="element-85">
              <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} data-id="element-86">
                <span className="text-lg font-semibold text-brand-text pr-8" data-id="element-87">
                  {faq.question}
                </span>
                <ChevronDown className={`flex-shrink-0 text-brand-teal transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-88" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-89">
                <p className="text-brand-muted leading-relaxed" data-id="element-90">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}